import DOMPurify from "dompurify"
import ReactHtmlParser from "html-react-parser"
import { RoutePathEnum } from "~Shared/router/RoutePath.enum"
import { linkNodeTransform } from "~Shared/utils/htmlParser.utils"

const { sanitize } = DOMPurify

DOMPurify.addHook("afterSanitizeAttributes", (node: any) => {
    if (!("target" in node)) {
        return
    }
    if (node.getAttribute("href")?.startsWith(RoutePathEnum.EMPLOYEES)) {
        return
    }
    node.setAttribute("target", "_blank")
    node.setAttribute("rel", "noopener") // for security issues
})

export const HtmlParserService = {
    parseHtml: (content: string) => ReactHtmlParser(sanitize(content), { replace: linkNodeTransform }),
}
